import { styled } from 'styled-components';

import { RETAILER_COLORS } from '@components/web/src/styles';

export const FooterWidgetAnonymousContainer = styled.div`
  width: 100%;
  height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  background-color: ${RETAILER_COLORS.primary['800']};
`;

export const Link = styled.button<{ $isHidden?: boolean }>`
  all: unset;
  display: ${({ $isHidden }) => ($isHidden ? 'none' : 'flex')};
  align-items: center;
  text-align: center;
  padding: 0 8px;
  cursor: pointer;
`;
